import { Link } from "react-router-dom";
import { useT } from "@/context/LanguageContext";
import { translations } from "@/data/translations";

export default function TermsConditions() {
  const t = useT(translations.terms);

  return (
    <div className="min-h-screen bg-[#1a1f26] text-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl py-16 md:py-24">
        <Link
          to="/"
          data-testid="terms-back-home"
          className="inline-flex items-center gap-2 text-sm text-[#b87b56] hover:text-[#d49a7a] transition-colors mb-8 uppercase tracking-wider font-medium"
        >
          ← {t.backHome}
        </Link>

        <h1
          data-testid="terms-title"
          className="text-4xl md:text-5xl font-bold tracking-tight uppercase mb-4"
          style={{ fontFamily: "Oswald, sans-serif" }}
        >
          {t.title}
        </h1>

        <p
          data-testid="terms-last-updated"
          className="text-sm text-slate-400 mb-12"
        >
          {t.lastUpdated}
        </p>

        <div className="space-y-10">
          <p className="text-slate-300 leading-relaxed">{t.intro}</p>

          {/* Acceptance */}
          <section data-testid="terms-section-acceptance">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.acceptance.title}
            </h2>
            <p className="text-slate-300 leading-relaxed">
              {t.acceptance.desc}
            </p>
          </section>

          {/* License */}
          <section data-testid="terms-section-license">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.license.title}
            </h2>
            <p className="text-slate-300 leading-relaxed">
              {t.license.desc}
            </p>
          </section>

          {/* Restrictions */}
          <section data-testid="terms-section-restrictions">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.restrictions.title}
            </h2>
            <p className="text-slate-300 leading-relaxed mb-3">
              {t.restrictions.desc}
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-300">
              {t.restrictions.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Purchases */}
          <section data-testid="terms-section-purchases">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.purchases.title}
            </h2>
            <p className="text-slate-300 leading-relaxed">
              {t.purchases.desc}
            </p>
          </section>

          {/* Liability */}
          <section data-testid="terms-section-liability">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.liability.title}
            </h2>
            <p className="text-slate-300 leading-relaxed">
              {t.liability.desc}
            </p>
          </section>

          {/* Changes */}
          <section data-testid="terms-section-changes">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.changes.title}
            </h2>
            <p className="text-slate-300 leading-relaxed">
              {t.changes.desc}
            </p>
          </section>

          {/* Contact */}
          <section data-testid="terms-section-contact">
            <h2
              className="text-xl font-bold uppercase tracking-wide mb-4 text-[#b87b56]"
              style={{ fontFamily: "Oswald, sans-serif" }}
            >
              {t.contact.title}
            </h2>
            <p className="text-slate-300 leading-relaxed">
              {t.contact.desc}
            </p>
            <a
              href="mailto:mmatimer.app@gmail.com"
              className="inline-block mt-2 text-[#b87b56] hover:text-[#d49a7a] transition-colors font-medium"
            >
              mmatimer.app@gmail.com
            </a>
          </section>
        </div>
      </div>
    </div>
  );
}
